module.exports = __webpack_public_path__ + "img/icon-teach.ab7c81ff.png";